import hotkeys from 'hotkeys-js';

// https://github.com/jaywcjlove/hotkeys/
export default class Keyboard {
  static map(keys, callback) {
    hotkeys(keys, function (event, handler) {
      callback(event, handler);
    });
  }
}
